import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    aboutList: () => {
        return HTTP.get('/about_current/1', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editAbout: (id,data) => {
        return HTTP.post(`/about_update/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}